import { apiClient } from "../config";

async function updateGlobalLayerStatus(
  geographyId: string,
  isArchived: boolean
) {
  const url = `/admin/geographies/${geographyId}/archive`;
  const res = await apiClient.put(url, { isArchived:isArchived });
  return res.data;
}

export default updateGlobalLayerStatus;
